import React, {useState} from 'react';
import cn from 'classnames';
import FleetList from 'components/myfleet_component/FleetList';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import styles from './myfleet.module.scss';
import Layout from 'components/mychargers_component/Layout';

// todo: Unless you need to use lifecycle methods or local state,
// write your component in functional form as above and delete
// this section. 

export default function MyFleet(props) {
	const [fleetLayout, setFleetLayout] =useState(false);
	const handleToggle = () => {
		//disabling click for 13june
		// setFleetLayout(!fleetLayout)
	}
	return (
		<div
			className={`dash-board1 ${cn(
				styles.main_block,
				styles.main_block_layout
			)}`}>

			<div className={cn(styles.main_flex, styles.main_flex_layout)}>
				<Header page_name='My Fleet'></Header>
				<div className={`max:${fleetLayout ? "hide" : "show"}`}>
					<FleetList navState={handleToggle}></FleetList>
				</div>
				<div className={`max:${fleetLayout ? "show" : "hide"}`}>

					<Layout navState={handleToggle} parking_slot_left_img='carParking' parking_slot_right_img='carParking' parking_slot_right_ic='carParking'
						parking_slot_left_ic='carParking'></Layout>
				</div>
				<Footer></Footer>
			</div>
		</div>
	);
}

MyFleet.inStorybook = true;
